import { useState } from 'react';
import { AppointmentSchedulerView } from '../types';
import { ProviderType } from '../../../api/types';
import { MeetingType } from '../../../models/meeting';

export const useAppointmentsPage = () => {
  const [currentView, setCurrentView] = useState<AppointmentSchedulerView>(
    AppointmentSchedulerView.MeetingTypePicker
  );

  const [selectedMeetingType, setSelectedMeetingType] =
    useState<MeetingType | null>(null);

  const [selectedProviderType, setSelectedProviderType] =
    useState<ProviderType | null>(null);

  const [highlightedMeetingId, setHighlightedMeetingId] = useState<
    number | null
  >(null);

  const goToDatePicker = (
    providerType: ProviderType,
    meetingType: MeetingType
  ) => {
    setCurrentView(AppointmentSchedulerView.DateTypePicker);
    setSelectedProviderType(providerType);
    setSelectedMeetingType(meetingType);
  };

  const goToMeetingTypePicker = () => {
    setCurrentView(AppointmentSchedulerView.MeetingTypePicker);
    setSelectedProviderType(null);
    setSelectedMeetingType(null);
    setHighlightedMeetingId(null);
  };

  const highlightMeetingId = setHighlightedMeetingId;

  return {
    currentView,
    goToDatePicker,
    goToMeetingTypePicker,
    highlightMeetingId,
    highlightedMeetingId,
    selectedMeetingType,
    selectedProviderType,
  };
};
